/**
 * 构建器注册表。新增报表类型只需在此注册，供 AI 按 reportType 分发。
 */

import type { ReportIR } from '../ir/types.js';
import { buildDetail } from './detail.js';
import { buildGroup } from './group.js';
import { buildCrosstab } from './crosstab.js';
import { buildMultiHeader } from './multiHeader.js';
import { buildParamQuery } from './paramQuery.js';
import { buildMasterDetail } from './masterDetail.js';

export { buildDetail, buildGroup, buildCrosstab, buildMultiHeader, buildParamQuery, buildMasterDetail };

const registry: Record<string, (input: any) => ReportIR> = {
  detail: buildDetail,
  group: buildGroup,
  crosstab: buildCrosstab,
  'multi-header': buildMultiHeader,
  'param-query': buildParamQuery,
  'master-detail': buildMasterDetail,
};

/** 按报表类型调用对应构建器。 */
export function buildReport(type: keyof typeof registry, input: any): ReportIR {
  const fn = registry[type];
  if (!fn) throw new Error(`未知报表类型：${type}（可选：detail/group/crosstab/multi-header/param-query/master-detail）`);
  return fn(input);
}
